import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { Card } from '@/components/ui/card'
import { Loader2 } from 'lucide-react'
import { PipelinesTab } from './AdminSuporte'

export default function AdminPipelines() {
  const { user, loading } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (loading) return
    if (!user) navigate('/auth', { replace: true })
  }, [user, loading, navigate])

  if (loading) return (
    <div className="flex items-center justify-center py-16">
      <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
    </div>
  )

  if (!user) return null

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-semibold">Pipelines</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Integrações ativas e histórico de execuções.
        </p>
      </div>
      <Card className="p-6">
        <PipelinesTab />
      </Card>
    </div>
  )
}
